import React from 'react';
import PropTypes from 'prop-types';

// This parent component "supervisorDashboard" not used anywhere, those are commented out 5 years back.
// So I commented the library usage "react-bootstrap-table-next" and library as well.
// "react-bootstrap-table-next": "^1.1.4",
// "react-bootstrap-table2-paginator": "^1.0.2",

// import BootstrapTable from 'react-bootstrap-table-next';
// import paginationFactory from 'react-bootstrap-table2-paginator';

const renderHeaderFormat = (column, sortElement, subtext) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, flexDirection: 'row' }}>
        {column.text}
        <span style={{ color: '#0c8ed7' }}>{sortElement}</span>
      </div>

      <div
        style={{
          flex: 1,
          flexDirection: 'column',
          paddingTop: '10px',
          borderTop: '3px solid #0c8ed7',
          marginTop: '5px'
        }}>
        {subtext}
      </div>
    </div>
  );
};

const SystemLoadTable = ({ data }) => {
  const defaultSorted = [
    {
      dataField: 'date',
      order: 'asc'
    }
  ];

  const futureLoadFormatter = (
    column,
    colIndex,
    { sortElement, filterElement }
  ) => {
    return renderHeaderFormat(column, sortElement, 'Future Load');
  };

  const newAlertsFormatter = (
    column,
    colIndex,
    { sortElement, filterElement }
  ) => {
    const futureLoad = data.future_load;
    const newAlerts = futureLoad.new_alerts;
    return renderHeaderFormat(column, sortElement, newAlerts);
  };

  const dailyAlertsClosedFormatter = (
    column,
    colIndex,
    { sortElement, filterElement }
  ) => {
    const futureLoad = data.future_load;
    const dailyAlertsClosed = futureLoad.daily_alerts_closed;
    return renderHeaderFormat(column, sortElement, dailyAlertsClosed);
  };

  const dailyUnresolvedFormatter = (
    column,
    colIndex,
    { sortElement, filterElement }
  ) => {
    const futureLoad = data.future_load;
    const dailyUnresolved = futureLoad.daily_unresolved;
    return renderHeaderFormat(column, sortElement, dailyUnresolved);
  };

  const dailyAvgNewFormatter = (
    column,
    colIndex,
    { sortElement, filterElement }
  ) => {
    const futureLoad = data.future_load;
    const dailyAvgNew = futureLoad.daily_avg_new;
    return renderHeaderFormat(column, sortElement, dailyAvgNew);
  };

  const noPeopleAvailableFormatter = (
    column,
    colIndex,
    { sortElement, filterElement }
  ) => {
    const futureLoad = data.future_load;
    const noPeopleAvailable = futureLoad.no_people_available;
    return renderHeaderFormat(column, sortElement, noPeopleAvailable);
  };

  const columns = [
    {
      dataField: 'date',
      text: 'Date',
      sort: true,
      headerFormatter: futureLoadFormatter
    },
    {
      dataField: 'new_alerts',
      text: 'Number of New Alerts',
      sort: true,
      headerFormatter: newAlertsFormatter
    },
    {
      dataField: 'daily_alerts_closed',
      text: 'Daily Alerts Closed',
      sort: true,
      headerFormatter: dailyAlertsClosedFormatter
    },
    {
      dataField: 'daily_unresolved',
      text: 'Daily Unresolved (Open + WIP)',
      sort: true,
      headerFormatter: dailyUnresolvedFormatter
    },
    {
      dataField: 'daily_avg_new',
      text: 'Daily Avg (New Alert)',
      sort: true,
      headerFormatter: dailyAvgNewFormatter
    },
    {
      dataField: 'no_people_available',
      text: 'No People Available',
      sort: true,
      headerFormatter: noPeopleAvailableFormatter
    }
  ];

  // const pagination = paginationFactory({
  //   hideSizePerPage: true,
  //   sizePerPage: 5
  // });

  // if (data) {
  //   return (
  //     <BootstrapTable
  //       bootstrap4
  //       striped
  //       keyField="_id"
  //       data={data.data}
  //       columns={columns}
  //       defaultSorted={defaultSorted}
  //       pagination={pagination}
  //     />
  //   );
  // }

  return <></>;
};

SystemLoadTable.propTypes = {
  data: PropTypes.object
};

export default SystemLoadTable;
